import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="glass corner-frame max-w-lg w-full p-12 text-center">
        <XCircle size={52} className="text-white/60 mx-auto" />
        <p className="mt-8 font-serif text-4xl text-white">Checkout cancelled</p>
        <p className="mt-4 text-white/60">No charge was made. Whenever you're ready, your resources are waiting.</p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/books" className="bg-gold-500 px-7 py-3.5 text-sm font-semibold text-ink hover:bg-gold-400 transition-colors">Back to Books</Link>
          <Link to="/academy" className="border border-gold-500/40 px-7 py-3.5 text-sm text-white/85 hover:border-gold-400 hover:text-gold-300 transition-colors">Browse Academy</Link>
        </div>
      </motion.div>
    </div>
  );
}
